declare namespace $ {

	type $bog_bzrl_app_hero_let__action_bog_bzrl_app_let_1 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_let['action'] >
		,
		ReturnType< $bog_bzrl_app_hero_let['action'] >
	>
	type $bog_bzrl_app_footer__attr_bog_bzrl_app_let_2 = $mol_type_enforce<
		({ 
			'id': string,
		}) 
		,
		ReturnType< $bog_bzrl_app_footer['attr'] >
	>
	export class $bog_bzrl_app_let extends $mol_view {
		action( next?: any ): any
		Let_hero( ): $bog_bzrl_app_hero_let
		Footer( ): $bog_bzrl_app_footer
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=let.view.tree.d.ts.map